import { paths } from "src/paths";

/** 기존 화면 경로에 진입 탭 query를 붙인다. */
export const buildTabPath = (path, key, value) =>
  `${path}?${new URLSearchParams({ [key]: value }).toString()}`;

/** 내부 데이터 탭을 내비게이션 하위 메뉴로 노출하기 위한 공용 정의다. */
export const DASHBOARD_TAB_SUBMENUS = {
  weekly: [
    { title: "지수", path: buildTabPath(paths.dashboard.condition.mainRegionIndex, "rank", "pi") },
    { title: "매물시세", path: buildTabPath(paths.dashboard.condition.mainRegionIndex, "rank", "mp") },
    { title: "거래량", path: buildTabPath(paths.dashboard.condition.mainRegionIndex, "rank", "rp") },
    { title: "매물수", path: buildTabPath(paths.dashboard.condition.mainRegionIndex, "rank", "sc") },
  ],
  monthly: [
    { title: "지수", path: buildTabPath(paths.dashboard.condition.mainRegionMonthly, "rank", "pi") },
    { title: "거래량", path: buildTabPath(paths.dashboard.condition.mainRegionMonthly, "rank", "rp") },
    { title: "매물수", path: buildTabPath(paths.dashboard.condition.mainRegionMonthly, "rank", "sc") },
    { title: "입주물량", path: buildTabPath(paths.dashboard.condition.mainRegionMonthly, "rank", "mi") },
    { title: "미분양", path: buildTabPath(paths.dashboard.condition.mainRegionMonthly, "rank", "us") },
  ],
  opportunity: [
    { title: "신고가", path: buildTabPath(paths.dashboard.condition.marketOpportunityStatus, "type", "newHigh") },
    { title: "가격저평가", path: buildTabPath(paths.dashboard.condition.marketOpportunityStatus, "type", "priceUndervalue") },
    { title: "회복중", path: buildTabPath(paths.dashboard.condition.marketOpportunityStatus, "type", "recovery") },
    { title: "고점대비하락", path: buildTabPath(paths.dashboard.condition.marketOpportunityStatus, "type", "peakDiscount") },
    { title: "하락중", path: buildTabPath(paths.dashboard.condition.marketOpportunityStatus, "type", "previousDrop") },
    { title: "거래량 증가", path: buildTabPath(paths.dashboard.condition.marketOpportunityStatus, "type", "volumeIncrease") },
    { title: "시세 상승", path: buildTabPath(paths.dashboard.condition.marketOpportunityStatus, "type", "priceIncrease") },
    { title: "매물수 감소", path: buildTabPath(paths.dashboard.condition.marketOpportunityStatus, "type", "listingDecrease") },
  ],
  undervalue: [
    { title: "가격저평가", path: buildTabPath(paths.dashboard.apts.undervalue, "mode", "price") },
    { title: "평형저평가", path: buildTabPath(paths.dashboard.apts.undervalue, "mode", "size") },
  ],
  newHighDrop: [
    { title: "신고가", path: buildTabPath(paths.dashboard.apts.newHighDrop, "mode", "newHigh") },
    { title: "회복중", path: buildTabPath(paths.dashboard.apts.newHighDrop, "mode", "recovery") },
    { title: "고점대비하락", path: buildTabPath(paths.dashboard.apts.newHighDrop, "mode", "peakDiscount") },
    { title: "하락중", path: buildTabPath(paths.dashboard.apts.newHighDrop, "mode", "previousDrop") },
  ],
};

/** 탭을 가진 상위 메뉴를 선택했을 때 진입할 첫 번째 탭 경로다. */
export const DASHBOARD_TAB_DEFAULT_PATHS = {
  weekly: DASHBOARD_TAB_SUBMENUS.weekly[0].path,
  monthly: DASHBOARD_TAB_SUBMENUS.monthly[0].path,
  opportunity: DASHBOARD_TAB_SUBMENUS.opportunity[0].path,
  undervalue: DASHBOARD_TAB_SUBMENUS.undervalue[0].path,
  newHighDrop: DASHBOARD_TAB_SUBMENUS.newHighDrop[0].path,
};

/** Keep the public menu unchanged while exposing bargain navigation to admins. */
export const getOpportunitySubmenus = (isAdmin = false) => {
  const items = DASHBOARD_TAB_SUBMENUS.opportunity;
  return isAdmin ? [
    items[0],
    { title: "급매", path: buildTabPath(paths.dashboard.condition.marketOpportunityStatus, "type", "bargain") },
    ...items.slice(1),
  ] : items;
};
